<template>
    <el-row class="pad-30">
        <el-form ref="form" :rules="rules" :model="form" label-width="85px" label-suffix=":">
            <el-col :span="12">
                <el-form-item label="模板编码">
                    <el-input size="small" v-model="form.code"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="模版内容">
                    <el-input type="textarea" :rows="5" v-model="form.content"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="内置模版">
                    <el-radio-group v-model="form.innerTemplate">
                        <el-radio label="内置模版"></el-radio>
                        <el-radio label="自定义模版"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="业务类型" prop="bizType">
                    <el-input size="small" v-model="form.bizType"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="接收类型">
                    <el-checkbox-group v-model="recipientType">
                        <el-checkbox label="接收人"></el-checkbox>
                        <el-checkbox label="接收角色"></el-checkbox>
                        <el-checkbox label="接收部门"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-col>

            <el-col :span="12" v-if="recipientType.indexOf('接收人')>=0">
                <el-form-item label="接收人" prop="recipient">
                    <el-select style="width: 100%" v-model="form.recipient" multiple filterable remote size="small" reserve-keyword placeholder="请输入接收人" :remote-method="remoteMethod"
                               :loading="loading" clearable>
                        <el-option v-for="item in dddd" :key="item.id" :label="item.name" :value="item.id">
                            <span style="float: left">{{item.name}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{item.deptName}}</span>
                        </el-option>
                        <el-pagination @current-change="handleCurrentChange2" :page-size="page.pageSize" layout="prev, pager, next" :total="page.total">
                        </el-pagination>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="24" class="mar-l-3f" v-if="recipientType.indexOf('接收角色')>=0">
                <avue-form v-model="form" :option="roleOption"></avue-form>
            </el-col>
            <el-col :span="24" class="mar-l-3f" v-if="recipientType.indexOf('接收部门')>=0">
                <avue-form v-model="form" :option="deptOption"></avue-form>
            </el-col>

            <el-col :span="24">
                <el-form-item :span="24">
                    <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
                    <el-button size="small" @click="close">取消</el-button>
                </el-form-item>
            </el-col>
        </el-form>
    </el-row>
</template>

<script>
import { saveMessageTemp, updateMessageTemp, getMessageTempDetail } from '@/api/desk/notice';
import { mapGetters, mapState } from 'vuex';
import { getDeptTree } from '@/api/system/dept';
import { getRoleList } from '@/api/system/role';
import { getList } from '@/api/system/user.js';

export default {
    components: {},
    data() {
        return {
            form: { recipientType: 1, innerTemplate: '内置模版' },
            roleList: [],
            deptList: [],
            recipientType: [],
            rules: {
                bizType: [{ required: true, message: '请输入业务类型', trigger: 'blur' }],
            },
            loading: false,
            dddd: [],
            list: [],
            queryName: '',
            page: {
                pageSize: 5,
                currentPage: 1,
                total: 0,
            },
            roleOption: {
                labelWidth: 85,
                menuBtn: false,
                colon: 'false',
                column: [
                    {
                        label: '接收角色',
                        display: true,
                        prop: 'receivingRole',
                        multiple: true,
                        type: 'tree',
                        colon: false,
                        dicData: [],
                        props: {
                            label: 'roleName',
                            value: 'id',
                        },
                        width: '400px',
                        checkStrictly: true,
                        slot: true,
                    },
                ],
            },
            deptOption: {
                labelWidth: 85,
                menuBtn: false,
                colon: 'false',
                column: [
                    {
                        label: '接收部门',
                        prop: 'receivingDept',
                        type: 'tree',
                        multiple: true,
                        dicData: [],
                        props: {
                            label: 'title',
                        },
                        checkStrictly: true,
                        slot: true,
                        display: true,
                    },
                ],
            },
        };
    },
    props: {
        currentEditRow: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    watch: {
        currentEditRow: {
            handler: function (newValue, oldName) {
                console.log(newValue);
                if (newValue.id) {
                    console.log(newValue);
                    this.getMessageTempDetail();
                } else {
                    this.form = { innerTemplate: '内置模版' };
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
        }),
    },
    mounted() {
        this.initData();
        this.getData();
    },

    methods: {
        getMessageTempDetail() {
            getMessageTempDetail(this.currentEditRow.id).then(res => {
                this.form = res.data.data;
                if (this.form.recipient != '') {
                    this.recipientType.push('接收人');
                    this.form.recipient = this.form.recipient.split(',');
                    console.log(this.form.recipient);
                    if (this.form.recipient.length > 0) {
                        this.form.recipient.forEach(element => {
                            this.getListById(element);
                        });
                    }
                }

                if (this.form.receivingRole != '') {
                    this.recipientType.push('接收角色');
                    this.form.receivingRole = this.form.receivingRole.split(',');
                }
                if (this.form.receivingDept != '') {
                    this.recipientType.push('接收部门');
                    this.form.receivingDept = this.form.receivingDept.split(',');
                }

                this.form.innerTemplate = this.form.innerTemplate == '1' ? '内置模版' : '自定义模版';
            });
        },
        async getListById(id) {
            await getList(this.page.currentPage, this.page.pageSize, { id: id }).then(res => {
                this.loading = false;
                this.dddd = this.dddd.concat(res.data.data.records);
                this.page.total = this.page.total + res.data.data.total;
            });
        },
        onSubmit() {
            this.form.innerTemplate = this.form.innerTemplate == '内置模版' ? 1 : 2;
            if (this.form.recipient) {
                if (this.recipientType.indexOf('接收人') >= 0) {
                    this.form.recipient = this.form.recipient.toString();
                } else {
                    this.form.recipient = '';
                }
            }
            if (this.form.receivingDept) {
                if (this.recipientType.indexOf('接收部门') >= 0) {
                    this.form.receivingDept = this.form.receivingDept.toString();
                } else {
                    this.form.receivingDept = '';
                }
            }
            if (this.form.receivingRole) {
                console.log(this.recipientType.indexOf('接收角色'), "this.recipientType.indexOf('接收角色')");
                if (this.recipientType.indexOf('接收角色') >= 0) {
                    this.form.receivingRole = this.form.receivingRole.toString();
                } else {
                    this.form.receivingRole = '';
                }
            }
            if (this.form.id) {
                updateMessageTemp(this.form).then(
                    res => {
                        this.$emit('close');
                    },
                    error => {
                        window.console.log(error);
                        loading();
                    },
                );
            } else {
                saveMessageTemp(this.form).then(
                    res => {
                        this.$emit('close');
                    },
                    error => {
                        window.console.log(error);
                        loading();
                    },
                );
            }
        },
        recipientTypeChange() {
            console.log(this.form);
        },
        close() {
            this.$emit('close');
        },
        initData() {
            getRoleList(1, 10000).then(res => {
                const column = this.findObject(this.roleOption.column, 'receivingRole');
                column.dicData = res.data.data;
            });
            getDeptTree(this.userInfo.tenant_id).then(res => {
                const column = this.findObject(this.deptOption.column, 'receivingDept');
                column.dicData = res.data.data;
            });
        },

        onLoad(page, params = {}) {
            this.loading = true;
            this.queryName = query;
            getList(page.currentPage, page.pageSize, Object.assign(params, this.query), this.treeDeptId).then(res => {
                const data = res.data.data;
                this.data = data.records;
            });
        },
        remoteMethod(query) {
            this.queryName = query;
            this.loading = true;
            this.getData();
            // let
            // this.getdata(this.page.currentPage, this.page.pageSize, { realName: this.queryName });
        },
        getData() {
            getList(this.page.currentPage, this.page.pageSize, { realName: this.queryName }).then(res => {
                this.loading = false;
                this.dddd = res.data.data.records;
                this.page.total = res.data.data.total;
            });
        },
        //分页方法
        handleCurrentChange2(val) {
            this.page.currentPage = val;
            this.getData();
        },
    },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
// /deep/ .el-select > .el-input {
//     width: 300px;
// }
</style>
